import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main-page-title" }
const _hoisted_2 = {
  class: "d-lg-flex container",
  style: {"margin-bottom":"80px"}
}
const _hoisted_3 = { class: "actions-btn-bar order-lg-1 mb-lg-0" }
const _hoisted_4 = { class: "d-flex align-items-center flex-grow-1" }
const _hoisted_5 = { class: "color-secodary" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "d-flex flex-column flex-md-row align-items-center" }
const _hoisted_8 = { class: "search-button-wrapper mx-2" }
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-search fs-24" }, null, -1)
const _hoisted_10 = { class: "show-all-clear-filter align-items-lg-center mx-2 mt-2 mt-md-0 text-nowrap" }
const _hoisted_11 = { class: "dashboard container container-flex" }
const _hoisted_12 = { class: "row mb-3" }
const _hoisted_13 = { class: "col-md-2 pb-2" }
const _hoisted_14 = { class: "block blue" }
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "col-md-2 pb-2" }
const _hoisted_18 = { class: "block blue" }
const _hoisted_19 = { class: "title" }
const _hoisted_20 = { class: "value" }
const _hoisted_21 = { class: "col-md-2 pb-2" }
const _hoisted_22 = { class: "block blue" }
const _hoisted_23 = { class: "title" }
const _hoisted_24 = { class: "value" }
const _hoisted_25 = { class: "row pb-4" }
const _hoisted_26 = { class: "col-md-2 pb-2" }
const _hoisted_27 = { class: "block" }
const _hoisted_28 = { class: "title two-line-md-only" }
const _hoisted_29 = { class: "col-md-2 pb-2" }
const _hoisted_30 = { class: "block" }
const _hoisted_31 = { class: "title two-line-md-only" }
const _hoisted_32 = { class: "col-md-2 pb-2" }
const _hoisted_33 = { class: "block" }
const _hoisted_34 = { class: "title two-line-md-only" }
const _hoisted_35 = { class: "block mb-4 px-4" }
const _hoisted_36 = { class: "table table-borderless mb-0" }
const _hoisted_37 = { class: "text-center" }
const _hoisted_38 = { class: "text-center" }
const _hoisted_39 = { class: "text-center" }
const _hoisted_40 = { class: "text-center" }
const _hoisted_41 = { class: "row mb-3" }
const _hoisted_42 = { class: "col-md-2 pb-2" }
const _hoisted_43 = { class: "block" }
const _hoisted_44 = { class: "title two-line-md-only" }
const _hoisted_45 = { class: "col-md-2 pb-2" }
const _hoisted_46 = { class: "block" }
const _hoisted_47 = { class: "title two-line-md-only" }
const _hoisted_48 = { class: "col-md-2 pb-2" }
const _hoisted_49 = { class: "block" }
const _hoisted_50 = { class: "title two-line-md-only" }
const _hoisted_51 = { class: "block px-4 mb-4" }
const _hoisted_52 = { class: "table table-borderless mb-0" }
const _hoisted_53 = { class: "text-center" }
const _hoisted_54 = { class: "text-center" }
const _hoisted_55 = { class: "text-center" }
const _hoisted_56 = { class: "text-center" }
const _hoisted_57 = { class: "row mb-3" }
const _hoisted_58 = { class: "col-md-2 pb-2" }
const _hoisted_59 = { class: "block px-3" }
const _hoisted_60 = { class: "title two-line-md-only" }
const _hoisted_61 = { class: "col-md-2 pb-2" }
const _hoisted_62 = { class: "block px-3" }
const _hoisted_63 = { class: "title two-line-md-only" }
const _hoisted_64 = { class: "col-md-2 pb-2" }
const _hoisted_65 = { class: "block px-3" }
const _hoisted_66 = { class: "title two-line-md-only" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_PieBlock = _resolveComponent("PieBlock")
  const _component_TimelineBlock = _resolveComponent("TimelineBlock")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('report.dashboard.title')), 1),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("button", {
          type: "button",
          class: "circle-btn btn-green",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.shortcut('today')))
        }, _toDisplayString(_ctx.$t('report.dashboard.shortcuts.today')), 1),
        _createVNode("button", {
          type: "button",
          class: "circle-btn btn-lred",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.shortcut('yesterday')))
        }, _toDisplayString(_ctx.$t('report.dashboard.shortcuts.yesterday')), 1),
        _createVNode("button", {
          type: "button",
          class: "circle-btn btn-orange",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.shortcut('week')))
        }, _toDisplayString(_ctx.$t('report.dashboard.shortcuts.week')), 1),
        _createVNode("button", {
          type: "button",
          class: "circle-btn btn-orange",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.shortcut('month')))
        }, _toDisplayString(_ctx.$t('report.dashboard.shortcuts.month')), 1)
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", null, [
          _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('report.dashboard.label.dates_filter')), 1),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", null, [
              _createVNode(_component_Calendar, {
                modelValue: _ctx.dateRange.fromDate,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dateRange.fromDate = $event)),
                selectionMode: "single",
                dateFormat: "dd/mm/yy",
                maxDate: _ctx.dateRange.toDate,
                class: "calendar-filter"
              }, null, 8, ["modelValue", "maxDate"]),
              _createVNode(_component_Calendar, {
                modelValue: _ctx.dateRange.toDate,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.dateRange.toDate = $event)),
                selectionMode: "single",
                dateFormat: "dd/mm/yy",
                minDate: _ctx.dateRange.fromDate,
                class: "calendar-filter mx-md-4"
              }, null, 8, ["modelValue", "minDate"])
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("button", {
                  type: "button",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.loadData && _ctx.loadData(...args)))
                }, [
                  _hoisted_9
                ])
              ]),
              _createVNode("div", _hoisted_10, [
                _createVNode("span", {
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.showAll && _ctx.showAll(...args)))
                }, _toDisplayString(_ctx.$t('button.showAll')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode("div", _hoisted_12, [
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('report.dashboard.total.orders')), 1),
            _createVNode("div", _hoisted_16, _toDisplayString(_ctx.reportGeneral.orders), 1)
          ])
        ]),
        _createVNode("div", _hoisted_17, [
          _createVNode("div", _hoisted_18, [
            _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('report.dashboard.total.quantity')), 1),
            _createVNode("div", _hoisted_20, _toDisplayString(_ctx.reportGeneral.quantity), 1)
          ])
        ]),
        _createVNode("div", _hoisted_21, [
          _createVNode("div", _hoisted_22, [
            _createVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('report.dashboard.total.amount')), 1),
            _createVNode("div", _hoisted_24, _toDisplayString(_ctx.reportGeneral.amount) + " " + _toDisplayString(_ctx.reportGeneral.currencySign), 1)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_25, [
        _createVNode("div", _hoisted_26, [
          _createVNode("div", _hoisted_27, [
            _createVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('report.dashboard.per_product.orders')), 1),
            _createVNode(_component_PieBlock, {
              data: _ctx.productPieData.orders
            }, null, 8, ["data"])
          ])
        ]),
        _createVNode("div", _hoisted_29, [
          _createVNode("div", _hoisted_30, [
            _createVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('report.dashboard.per_product.quantity')), 1),
            _createVNode(_component_PieBlock, {
              data: _ctx.productPieData.quantity
            }, null, 8, ["data"])
          ])
        ]),
        _createVNode("div", _hoisted_32, [
          _createVNode("div", _hoisted_33, [
            _createVNode("div", _hoisted_34, _toDisplayString(_ctx.$t('report.dashboard.per_product.amount')), 1),
            _createVNode(_component_PieBlock, {
              data: _ctx.productPieData.amount
            }, null, 8, ["data"])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_35, [
        _createVNode("table", _hoisted_36, [
          _createVNode("tr", null, [
            _createVNode("th", null, _toDisplayString(_ctx.$t('report.dashboard.table.product')), 1),
            _createVNode("th", _hoisted_37, _toDisplayString(_ctx.$t('report.dashboard.table.quantity')), 1),
            _createVNode("th", _hoisted_38, _toDisplayString(_ctx.$t('report.dashboard.table.amount')), 1)
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reportProducts, (row) => {
            return (_openBlock(), _createBlock("tr", {
              key: row.id
            }, [
              _createVNode("td", null, _toDisplayString(row.name), 1),
              _createVNode("td", _hoisted_39, _toDisplayString(row.quantity), 1),
              _createVNode("td", _hoisted_40, _toDisplayString(row.amount.toFixed(2)) + " " + _toDisplayString(row.currencySign), 1)
            ]))
          }), 128))
        ])
      ]),
      _createVNode("div", _hoisted_41, [
        _createVNode("div", _hoisted_42, [
          _createVNode("div", _hoisted_43, [
            _createVNode("div", _hoisted_44, _toDisplayString(_ctx.$t('report.dashboard.per_priceType.orders')), 1),
            _createVNode(_component_PieBlock, {
              data: _ctx.priceTypePieData.orders
            }, null, 8, ["data"])
          ])
        ]),
        _createVNode("div", _hoisted_45, [
          _createVNode("div", _hoisted_46, [
            _createVNode("div", _hoisted_47, _toDisplayString(_ctx.$t('report.dashboard.per_priceType.quantity')), 1),
            _createVNode(_component_PieBlock, {
              data: _ctx.priceTypePieData.quantity
            }, null, 8, ["data"])
          ])
        ]),
        _createVNode("div", _hoisted_48, [
          _createVNode("div", _hoisted_49, [
            _createVNode("div", _hoisted_50, _toDisplayString(_ctx.$t('report.dashboard.per_priceType.amount')), 1),
            _createVNode(_component_PieBlock, {
              data: _ctx.priceTypePieData.amount
            }, null, 8, ["data"])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_51, [
        _createVNode("table", _hoisted_52, [
          _createVNode("tr", null, [
            _createVNode("th", null, _toDisplayString(_ctx.$t('report.dashboard.table.priceType')), 1),
            _createVNode("th", _hoisted_53, _toDisplayString(_ctx.$t('report.dashboard.table.quantity')), 1),
            _createVNode("th", _hoisted_54, _toDisplayString(_ctx.$t('report.dashboard.table.amount')), 1)
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reportPriceTypes, (row) => {
            return (_openBlock(), _createBlock("tr", {
              key: row.id
            }, [
              _createVNode("td", null, _toDisplayString(row.name), 1),
              _createVNode("td", _hoisted_55, _toDisplayString(row.quantity), 1),
              _createVNode("td", _hoisted_56, _toDisplayString(row.amount.toFixed(2)) + " " + _toDisplayString(row.currencySign), 1)
            ]))
          }), 128))
        ])
      ]),
      _createVNode("div", _hoisted_57, [
        _createVNode("div", _hoisted_58, [
          _createVNode("div", _hoisted_59, [
            _createVNode("div", _hoisted_60, _toDisplayString(_ctx.$t('report.dashboard.timeline.orders')), 1),
            _createVNode(_component_TimelineBlock, {
              data: _ctx.timeline.orders
            }, null, 8, ["data"])
          ])
        ]),
        _createVNode("div", _hoisted_61, [
          _createVNode("div", _hoisted_62, [
            _createVNode("div", _hoisted_63, _toDisplayString(_ctx.$t('report.dashboard.timeline.quantity')), 1),
            _createVNode(_component_TimelineBlock, {
              data: _ctx.timeline.quantity
            }, null, 8, ["data"])
          ])
        ]),
        _createVNode("div", _hoisted_64, [
          _createVNode("div", _hoisted_65, [
            _createVNode("div", _hoisted_66, _toDisplayString(_ctx.$t('report.dashboard.timeline.amount')), 1),
            _createVNode(_component_TimelineBlock, {
              data: _ctx.timeline.amount,
              labelsY: _ctx.currencyFormat
            }, null, 8, ["data", "labelsY"])
          ])
        ])
      ])
    ])
  ]))
}